module.exports = __webpack_public_path__ + "img/case-logo-10.c9bf9021.png";